import { useSyncExternalStore } from 'react'
import { HealthStateX } from '../../../types/mfc'
import { pubSub } from '../../app-state/pubSub'
import { appState } from '../../app-state/state.app'
import { getHealthState } from '../../app-state/state.health'

const subHealthState = (callback) => pubSub.HEALTH.on('state', callback)
const getHealthStateSelector =
    <T extends keyof HealthStateX>(key: T) =>
    () =>
        appState().HEALTH[key]

export const useHealthAppState = (): HealthStateX => {
    return useSyncExternalStore(subHealthState, getHealthState, getHealthState)
}

export const useHealthAppStateSelector = <T extends keyof HealthStateX>(
    key: T,
): HealthStateX[T] => {
    return useSyncExternalStore(
        subHealthState,
        getHealthStateSelector(key),
        getHealthStateSelector(key),
    )
}
